module.exports = __webpack_public_path__ + "static/media/loading.ebafcbb8.svg";